import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { Observable, of } from 'rxjs';

import { TargetingSearchComponent } from '../../Targeting/components/TargetingSearch/targeting-search.component';
import { TargetingSearchesService } from '../../Targeting/services/targeting-searches.service';
import { DiscoverRoutingService } from '../services/discover-routing.service';
import { DiscoverRouteModel } from '../models/discover-route.model';
import { DiscoverRouteTypeEnum } from '../enums/discover-route-type.enum';

@Injectable()
export class TargetingSearchDeactivateGuard implements CanDeactivate<TargetingSearchComponent> {

    searchDirty: boolean = false;
    currentRoute: DiscoverRouteModel;

    constructor(
        private targetingSearchesService: TargetingSearchesService,
        private discoverRoutingService: DiscoverRoutingService
    ) {
        this.targetingSearchesService.resourceDirty$.subscribe(dirty => {
            this.searchDirty = dirty;
        });
        this.discoverRoutingService.getCurrentRoute().subscribe(x => this.currentRoute = x);
    }

    canDeactivate(
        component: TargetingSearchComponent
    ): Observable<boolean> {
        const destinationRoute = this.discoverRoutingService.getNextRoute();
        const canSkipGuard: boolean = this.canSkipGuard(this.currentRoute, destinationRoute);

        if (canSkipGuard) {
            return of(true);
        }

        return this.targetingSearchesService.canDeactivate$();
    }

    canSkipGuard(currentRoute: DiscoverRouteModel, nextRoute: DiscoverRouteModel): boolean {
        if (!this.searchDirty || this.targetingSearchesService.creatingNewSearch) {
            this.targetingSearchesService.creatingNewSearch = false;
            return true;
        }

        // Can be null if next route is not a Discover route
        if (nextRoute) {
            // These two mean the search button was pressed, so nothing will be
            // lost by going to the result page
            if (nextRoute.type === DiscoverRouteTypeEnum.targetingSavedSearchResults
                || nextRoute.type === DiscoverRouteTypeEnum.targetingSavedSearch) {
                return nextRoute.value === currentRoute.value;
            }
            // Fresh search
            if (nextRoute.type === DiscoverRouteTypeEnum.targetingResults) {
                return currentRoute.type === DiscoverRouteTypeEnum.targetingSearchUpdate ||
                    currentRoute.type === DiscoverRouteTypeEnum.targetingSearch;
            }

            // Editing a fresh search
            if (nextRoute.type === DiscoverRouteTypeEnum.targetingSearchUpdate
                || nextRoute.type === DiscoverRouteTypeEnum.targetingSearch) {
                return currentRoute.type === DiscoverRouteTypeEnum.targetingResults;
            }
        }

        return false;
    }
}
